import { GeorefData } from '../../../../../../store/uploadStore';
import { readGeoref } from './readGeoref';
import { uploadGeoref } from './uploadGeoref';
import { v4 as uuidv4 } from 'uuid';
import { trackAction } from '../../../../../../libs/analytics/ActionTracking';
import { Customer, Site } from '../../../../../../types';
import { FileWithPath } from 'react-dropzone';

export const useHandlePpkGeorefAdd = (
  customer: Customer,
  site: Site,
  getGeoRef: () => GeorefData | undefined,
  setGeoRef: (geoRef: GeorefData) => void,
) => {
  return (files: FileWithPath[]) => {
    if (!files.length) return;

    const file = files[0];
    const abortController = new AbortController();

    trackAction('Click to select georef file', { customer, site });

    setGeoRef({
      meta: {
        name: file.name,
        size: file.size!,
        uploadedSize: 0,
        abortController,
        isRegistrationRequestSent: false,
        georefUploadPath: `${uuidv4()}/georef/georef.txt`,
      },
      georef: undefined,
    });

    readGeoref(file)
      .then((georef) => {
        const current = getGeoRef();
        if (current && !current.meta.abortController.signal.aborted) {
          setGeoRef({
            ...current,
            georef,
          });
        }
      })
      .catch(() => {
        const current = getGeoRef();
        if (current && !current.meta.abortController.signal.aborted) {
          current.meta.error = 'Failed to read the Georeferencing file';
          setGeoRef({
            ...current,
          });
        }
      });

    // Note that here we only upload the file via BSP. It is only registered (or re-registered) once user
    // picks a file (because the confirmation dialog might change the scan date when the user picks an image).
    uploadGeoref(file, customer.id, site.id, getGeoRef, setGeoRef, abortController);
  };
};
